// A '\n\n' boundary is only stable when it's outside a fenced code block —
// splitting inside a fence would break rendering of both halves.
const lastStableBoundaryIndex = (content) => {
  let searchEnd = content.length;
  while (searchEnd > 0) {
    const boundary = content.lastIndexOf('\n\n', searchEnd - 1);
    if (boundary === -1) return -1;

    const fenceCount = (content.slice(0, boundary).match(/```/g) || []).length;
    if (fenceCount % 2 === 0) return boundary;

    searchEnd = boundary;
  }

  return -1;
};

export const splitStreamingContent = (content) => {
  const boundary = lastStableBoundaryIndex(content);
  if (boundary === -1) return { stableBlocks: [], tail: content };

  return {
    stableBlocks: content.slice(0, boundary).split('\n\n'),
    tail: content.slice(boundary + 2)
  };
};

export const withholdPartialTableRow = (tail) => {
  const newlineIndex = tail.lastIndexOf('\n');
  const lastLine = tail.slice(newlineIndex + 1);
  if (lastLine.trimStart().startsWith('|')) {
    return tail.slice(0, newlineIndex + 1);
  }

  return tail;
};
